;(() => {
  //add event listener for any quick-view buttons already existing on page load
  document
    .querySelectorAll('.product-card .btn-quickview')
    .forEach((button) => {
      handleQuickViewClick(button)
    })

  const quickViewButtonSelector = '.btn-quickview'
  const quickViewButtonObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches(quickViewButtonSelector)
        ) {
          handleQuickViewClick(node)
        }
        //also check child nodes
        node
          .querySelectorAll?.(quickViewButtonSelector)
          .forEach((child) => handleQuickViewClick(child))
      })
    })
  })

  //add event listener for any quick-view buttons added dynamically e.g. with Nosto
  quickViewButtonObserver.observe(document.body, {
    childList: true,
    subtree: true
  })

  function handleQuickViewClick(element) {
    element.addEventListener('click', async function (event) {
      event.preventDefault() //prevent user being navigated to product page

      const productUrl = this.closest('.product-card').getAttribute('href')

      try {
        const response = await fetch(
          `${productUrl}${
            productUrl.includes('?') ? '&' : '?'
          }section_id=product-quickview`
        )
        const responseText = await response.text()

        const parser = new DOMParser()
        const doc = parser.parseFromString(responseText, 'text/html')

        const sectionProduct =
          doc.querySelector('section.product-main')?.outerHTML || null
        document.querySelector('section#modal main.wrapper').innerHTML =
          sectionProduct

        const sectionProductScript =
          doc.querySelector('script.product-main-script')?.innerHTML || null
        const script = document.createElement('script')
        script.textContent = sectionProductScript
        document.querySelector('section#modal main.wrapper').appendChild(script)

        document.querySelector('section#modal').classList.add('active')
      } catch (error) {
        console.error('failed to get product quick view: ', error)
      }
    })
  }
})()
